export function mobileMenu() {
  const navbar = document.querySelector('#app');
  const ham = document.querySelector('.burger');

  const mediaQueries = window.matchMedia('(max-width: 639px)');
  const headerBtns = document.querySelector('.js-nav-header-btn');
  const headerBtnlastChild = headerBtns.lastElementChild;
  const lastChildUrl = headerBtnlastChild.querySelector('a');
  const lastChildText = headerBtnlastChild.textContent;
  const menu = document.querySelector('.js-nav-header');
  const newBtn = document.createElement('a');

  function toggleHamburger() {
    navbar.classList.toggle('showNav');
    ham.classList.toggle('showClose');
  }

  function displayMobileButton() {
    headerBtnlastChild.classList.add('hidden');
    newBtn.classList.remove('hidden');
  }

  function hideMobileButton() {
    headerBtnlastChild.classList.remove('hidden');
    newBtn.classList.add('hidden');
  }

  function initMobileButton() {
    newBtn.innerText = lastChildText;
    newBtn.href = lastChildUrl;
    newBtn.classList.add('hidden', 'color-4', 'inline-block', 'mx-auto', 'text-white', 'py-4', 'px-16', 'mt-4', 'font-medium');
    menu.appendChild(newBtn);

    if (mediaQueries.matches) {
      displayMobileButton();
    } else {
      hideMobileButton();
    }

    window.addEventListener('resize', () => {
      if (mediaQueries.matches) {
        displayMobileButton();
      } else {
        hideMobileButton();
      }
    });
  }

  initMobileButton();

  ham.addEventListener('click', toggleHamburger);

  const menuLinks = document.querySelectorAll('.menuLink');
  menuLinks.forEach(
    (menuLink) => {
      menuLink.addEventListener('click', toggleHamburger);
    },
  );
}
